var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoundArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "head",
    orient: "auto",
    markerWidth: 4,
    markerHeight: 4,
    refX: 0.1,
    refY: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 V4 L4,2 Z",
    fill: "#AFAFE9"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow1",
    refX: 0,
    refY: 1.8,
    markerUnits: "strokeWidth",
    markerWidth: 10,
    markerHeight: 10,
    orient: "auto",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,4 L6,2 z",
    stroke: "#AFAFE9",
    fill: "#AFAFE9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "black",
    fillRule: "evenodd",
    stroke: "#AFAFE9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 26,
    y2: 20,
    stroke: "#AFAFE9",
    strokeWidth: 4,
    markerEnd: "url(#head)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 20  h-2   a10 10 0 0 1 -10 -10 v-40",
    stroke: "#AFAFE9",
    strokeWidth: 4,
    fill: "transparent"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoundArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/roundArrow.2742b2df4b6adf30267ace6871b4e32f.svg";